// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_EC-l1","btn-close":"btn-close_ZfVZm","g-body-pc":"g-body-pc","icon-x":"icon-x"};